import { Box } from '@common-fe/common-fe';
import styled, { css } from 'styled-components';

interface WrapperProps {
  imageSrc?: string;
  $isMobile?: boolean;
}

export const ManageProfileDashboardWrapper = styled(Box)<WrapperProps>`
  position: relative;
  min-height: 340px;
  justify-content: center;
  background-size: cover;
  background-color: ${({ theme }) => theme.colors.background1};
  background-repeat: no-repeat;
  background-image: url('${({ imageSrc }) => imageSrc}');

  ${({ theme, $isMobile }) => {
    if ($isMobile) {
      return css`
        min-height: inherit;
        justify-content: start;
        margin: 0 2px;
        padding: ${theme.spacings.spacing24};
      `;
    }
    return css`
      padding-top: ${theme.spacings.spacing24};
      padding-bottom: ${theme.spacings.spacing24};
      padding-left: ${theme.spacings.spacing72};
      padding-right: 144px;
    `;
  }}
  border-radius: ${({ theme }) => theme.rounds.moduleRound};
`;

export const ManageProfileDashboardContent = styled(Box)`
  position: relative;
  z-index: 1;
  width: 100%;
`;
